<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 营销模块
        </el-breadcrumb-item>
        <el-breadcrumb-item>促销政策-分销商</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <el-tabs type="card" v-model="activeName" @tab-click="$refs.tabpane1.search(),$refs.tabpane2.search()">
        <el-tab-pane label="待配置" name="first">
          <div class="handle-box">
            <el-form ref="searchform" :model="searchform" label-width="80px">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="出库单号" prop="outBillCode">
                    <el-input v-model="searchform.outBillCode" style="width:100%" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="包装级别" prop="awardObject">
                    <el-select
                      v-model="searchform.packageLevel"
                      placeholder="请选择"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in packageLevellist"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="产品编码" prop="productCode">
                    <el-input v-model="searchform.productCode" style="width:100%" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="批次号" prop="bacthNo">
                    <el-input v-model="searchform.bacthNo" style="width:100%" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8" :offset="1">
                  <el-button @click="resetForm('searchform')">重置</el-button>
                  <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                  <el-button type="primary" @click="getuuidlist()">配置规则</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <br />
          <!--步骤条 填写基础信息 -->
          <deploy-rule :add="add" :search="search" />
          <el-row type="flex" class="row-bg">
            <el-col :span="24" class="border">
              <h4>促销政策列表-待配置</h4>
              <el-divider></el-divider>
              <el-table
                border
                v-loading="listLoading"
                element-loading-text="拼命加载中"
                :data="tableData"
                style="width:100%;"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column prop="outbillAssigned.outBillCode" label="出库单号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outbillAssigned.batchNo" label="批次号" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outbillAssigned.outbillCount" label="出库数量" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outbillAssigned.productName" label="产品名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outbillAssigned.productCode" label="产品编码" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column
                  prop="awardType"
                  label="奖励类型"
                  min-width="100"
                  show-overflow-tooltip
                ></el-table-column>
          <el-table-column prop="outbillAssigned.dealerName" label="经销商名称" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outbillAssigned.address" label="经销商地址" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column
                  prop="assignStatename"
                  label="状态"
                  min-width="150"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
              <br />
              <el-pagination
                background
                @current-change="currentchange"
                @size-change="pagesize"
                :current-page.sync="currentPage"
                :page-sizes="[10,20,30,50]"
                layout="total,prev, pager, next,jumper,sizes"
                :total="total_count"
              ></el-pagination>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="待审核" name="second">
          <Check-Pending :packdate="packdate" ref="tabpane1"  />
        </el-tab-pane>
        <el-tab-pane label="已配置" name="third">
          <Confi-Gured :packdate="packdate" ref="tabpane2" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import {
  updatestate,
  distributorUnAssigned
} from "@/api/market/marketing";
import DeployRule from "./components/DeployRule";
import CheckPending from "./components/CheckPending";
import ConfiGured from "./components/ConfiGured";
//引入导出组件模块
export default {
  name: "promotionpolicy",
  components: { DeployRule, CheckPending, ConfiGured },
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
  },
  data() {
    return {
      //基础数据
      multipleSelection: [],
      activeName: "first",
      add: {
        count:0,
        addshow: false,
        uuids: []
      },
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      packageLevellist: [
        {
          value: 1,
          label: "一级包装"
        },
        {
          value: 2,
          label: "二级包装"
        }
      ],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      searchform: {
        datelist: [],
        outBillCode: null,
        packageLevel: 2,
        productCode: null,
        bacthNo: null,
        // state: 0,
        page: 1,
        pageSize: 10
      },
      // 待审核模块对象
      second: {}
    };
  },
  methods: {
    next() {
      // 步骤条
      this.show = !this.show;
      if (this.active++ >= 2) {
        this.active = 1;
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      distributorUnAssigned(obj).then(response => {
        this.tableData = response.data.rows;
        this.packdate(this.tableData);
        this.total_count = response.data.total;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        switch (obj[i].assignState) {
          case 0:
            obj[i].assignStatename = "待配置";
            break;
          case 1:
            obj[i].assignStatename = "待审核";
            break;
          case 2:
            obj[i].assignStatename = "已配置";
            break;
          default:
            break;
        }
        switch (obj[i].awardType) {
          case '0':
          obj[i].awardType = "金额";
          break;
        case '1':
          obj[i].awardType = "积分";
          break;
        case '2':
          obj[i].awardType = "实物";
          break;
        case '3':
          obj[i].awardType = "优惠卷";
          break;
        default:
          break;
        }
      }
    },
    //搜索事件
    search() {
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.page = currPage;
      this.Tabledata(this.searchform);
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getuuidlist() {
      this.add.uuids = [];
      this.add.count= 0;
      if (this.multipleSelection.length ==0) {
                this.$message({
          type: "warning",
          message: "未勾选出库单"
        });
      } else {
        this.add.addshow = !this.add.addshow;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          this.add.uuids.push(this.multipleSelection[i].outBillUuid);
          this.add.count +=this.multipleSelection[i].outbillAssigned.qrcode2Count;
        }
        console.log(this.add.count)
      }
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>